<template>
    <q-tabs color="faded" inverted position="top" align="justify" class="bg-white">
        <q-route-tab v-for="menu in menus" :key="menu.name" animated="false" slot="title" :to="(menu.slug !== '/alertas' ? '/noticias/' : '') + menu.slug">
            <img class="icon-tab" :src="menu.image_path">
            <span>{{ $T(menu.name) }}</span>
        </q-route-tab>
    </q-tabs>
</template>

<script>
    import {
        QTabs,
        QRouteTab
    } from 'quasar-framework'
    import axios from 'axios';
    export default {
        components: {
            QTabs,
            QRouteTab
        },
        data() {
          return {
            appUrl: window.config.appUrl
          }
        },
        computed: {
            menus: {
                get() {
                    if(this.$store.state.categories.user_categories.length<=0)
                        this.$store.dispatch("categories/fetchCategories")
                    return this.$store.state.categories.user_categories

                },
                set(value) {
                    console.log(value);
                    this.$store.dispatch('categories/updateCategories', {user_categories: value})
                }

            },

            devFolder() {
                return window.config.devAssetsFolder
            }
        },
        methods: {
            redirect(slug) {
                window.location.href = slug
            },
        }
    }
</script>

<style lang="stylus" scoped>
    .icon-tab
        width 35px
</style>



// WEBPACK FOOTER //
// resources/assets/js/components/Footer.vue